import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

//Configurar datos de firebase
firebase.initializeApp({
  apiKey: "AIzaSyDos4ELuQ8EdnhWLRPXTIxvZdskTyiXbVQ",
  authDomain: "fottom-flux.firebaseapp.com",
  databaseURL: "https://fottom-flux.firebaseio.com",
  projectId: "fottom-flux",
  storageBucket: "fottom-flux.appspot.com",
  messagingSenderId: "700181822538",
  appId: "1:700181822538:web:7542f8b68ed2a323757ab3",
  measurementId: "G-WRK0GLT2GR"
})

//Configuracion de firebase
const conn_vuefire = firebase.firestore()
//Si se utiliza Firebase JS SDK < 5.8.0
/*const settings = {timestampsInSnapshots: true}
conn_vuefire.settings(settings)*/

//Variables para conexion
const db = conn_vuefire
const auth = firebase.auth()

//Limitar cache
db.settings({
  cacheSizeBytes: 100 * 1000000 //25 * 1000000 25 MB //firebase.firestore.CACHE_SIZE_UNLIMITED //https://firebase.google.com/docs/firestore/manage-data/enable-offline
})

//Habilitar soporte offline antes db.enablePersistence()
db.enablePersistence({ synchronizeTabs: true })
.then(function() {
    //Iniciar Cloud Firestore a través de firebase
    console.log('connection sucess')
})
.catch(function(err) {
    if(err.code == 'failed-precondition'){
      //Existe mas de una pestaña abierta
      alert('Existe más de una pestaña usando esta app, la persistencia solo funciona en una pestaña a la vez')
    }else if (err.code == 'unimplemented'){
      //Sin soporte para el navegador
      alert('Este navegador no soporta todas las configuraciones necesarias para habilitar la persistencia')
    }
})

// const timestamp = snapshot.get('created_at')
// const date = timestamp.toDate()

export {
  db, 
  auth
}